import { render, staticRenderFns } from "./NotifyModal.vue?vue&type=template&id=67539ff4&scoped=true"
import script from "./NotifyModal.vue?vue&type=script&lang=js"
export * from "./NotifyModal.vue?vue&type=script&lang=js"
import style0 from "./NotifyModal.vue?vue&type=style&index=0&id=67539ff4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67539ff4",
  null
  
)

export default component.exports